export interface ActionBar {
  actionBarVisible?: boolean;
  showBackButton?: boolean;
  showPageTitle?: boolean;
}
